import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService } from "primeng/api";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { VenueInternet } from "src/app/shared/models/VenueInternet.model";

@Component({
	selector: "app-internet-history-report",
	templateUrl: "./internet-history-report.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class InternetHistoryReportComponent implements OnInit, OnDestroy {
	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	last24hrs: number;
	last30days: number;

	moment: any = moment;

	venueInternetHistory: VenueInternet[];
	venueChangeSubscription: Subscription;
	venueKey: number;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		private spinner: NgxSpinnerService,
		private userService: UserService,
		public imgCrop: ImageCropperService,
		public venueSvc: OOVenueService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.spinner.show();
		this.init();
	}

	ngOnDestroy() {
		this.venueChangeSubscription.unsubscribe();
	}

	async init() {
		const venue = await this.localStorage.get("venue");
		this.venueKey = venue.key;
		await this.load();
		this.venueChangeSubscription = this.localStorage.getVenue().subscribe(async (data) => {
			if (this.venueKey !== data.key) {
				this.spinner.show();

				this.venueKey = data.key;
				await this.load();
			}
		});
	}

	async load() {
		await this.venueInternetHistoryGet(this.venueKey);
		this.spinner.hide();
	}

	async venueInternetHistoryGet(venueKey) {
		const resp = await this.focuslink.venueInternetGet(venueKey);
		this.venueInternetHistory = resp.map((i) => {
			return new VenueInternet(i);
		});
		this.last24hrs = this.venueInternetHistory.filter((i) => moment(i.disconnectDateTime).isAfter(moment().add(-24, "hour"))).length;
		this.last30days = this.venueInternetHistory.filter((i) => moment(i.disconnectDateTime).isAfter(moment().add(30, "day"))).length;
	}
}
